import { useState } from "react";

import classNames from "classnames/bind";
import CarouselSwiper from "common/blocks/Carousel/CarouselSwiper";

import styles from "./Tabs.module.scss";

const cx = classNames.bind(styles);

type Tab = {
    tabName: string;
    component: JSX.Element;
};

export type TabsData = Tab[];

type TabsComponentProps = {
    tabs: TabsData;
    className?: string;
    containerClassName?: string;
    activeTabClassName?: string;
    tabClassName?: string;
    tabNameDefaultSelected?: string;
    hideTabs?: boolean;
    tabsWrapperClassname?: string;
};

const Tabs: React.FC<TabsComponentProps> = ({
    tabs,
    className,
    containerClassName,
    activeTabClassName,
    tabClassName,
    tabNameDefaultSelected,
    hideTabs = false,
    tabsWrapperClassname,
}) => {
    const [isSelected, setIsSelected] = useState(tabNameDefaultSelected ?? tabs[0].tabName);

    const currentRenderedTab = tabs.find((tab) => tab.tabName === isSelected);

    return (
        <div className={cx("container", containerClassName)}>
            {!hideTabs && (
                <div className={cx("tabs", tabsWrapperClassname)}>
                    <CarouselSwiper spaceBetween={10} id="tabsCarousel">
                        {tabs.map((tab, index) => {
                            const tabSelected = isSelected === tab.tabName;
                            if (!tab.tabName) return null;
                            return (
                                <div key={tab.tabName}>
                                    <h2
                                        className={cx(
                                            "tab",
                                            tabClassName,
                                            tabSelected && "selected",
                                            tabSelected && activeTabClassName
                                        )}
                                        onClick={() => setIsSelected(tab.tabName)}
                                        data-testid={`click-tab-${index + 1}`}
                                    >
                                        {tab.tabName}
                                    </h2>
                                </div>
                            );
                        })}
                    </CarouselSwiper>
                </div>
            )}
            <div data-testid="live-area" className={cx("component", className)}>
                {isSelected && currentRenderedTab?.component}
            </div>
        </div>
    );
};

export default Tabs;
